export const FOOTER_HEIGHT = 120
export const HEADER_HEIGHT = 64

export const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export const CYCLE_STATES = {
  'Awaiting Approval': {
    text: 'Awaiting Approval',
    color: 'bg-blue-200 text-blue-950',
  },
  'Awaiting Executive Approval': {
    text: 'Awaiting Executive Approval',
    color: 'bg-blue-200 text-blue-950',
  },
  Closed: {
    text: 'Closed',
    color: 'bg-red text-white',
  },
  'Not Started': {
    text: 'Not Started',
    color: 'bg-white-dark text-blue-950',
  },
  'In Progress': {
    text: 'In Progress',
    color: 'bg-white-dark text-blue-950',
  },
  'Submitted to Billing': {
    text: 'Submitted',
    color: 'bg-[#41A200] text-white',
  },
}

export const BILLING_CYCLE_STATE_OPTIONS = Object.keys(CYCLE_STATES).map((key) => ({
  id: key,
  label: CYCLE_STATES[key].text,
}))
